<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 13:36:47
 * @FilePath: \mrc-ess-fronted\src\Layout\Home.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-18 17:47:53
-->
<template>
  <v-app id="inspire" class="transparent" app>
    <SlideLeft :stretch="stretchL" :naviData="naviData" />
    <Navi
      :popR="popR"
      :stretchL="stretchL"
      @onStretch="
        (s) => {
          stretchL = s;
        }
      "
      @onPop="
        (s) => {
          popR = s;
        }
      "
    />
    <Container
      :stretch="popR"
      :stretchL="stretchL"
      :stretchR="stretchR"
      @slideRightChange="stretchR = !stretchR"
      @onPopChange="
        (s) => {
          popR = s;
        }
      "
    />

    <SlideRight
      :hidden="isHidden"
      :stretch="stretchR"
      @onStretch="
        (s) => {
          stretchR = s;
        }
      "
    />
    <MsgStatus />
  </v-app>
</template>

<script>
import SlideLeft from "@/Layout/components/SlideLeft";
import MsgStatus from "@/Layout/components/MsgStatus";
import SlideRight from "@/Layout/components/SlideRight";
import Navi from "@/Layout/components/Navi";
import Container from "@/Layout/components/Container";
// import Footer from "@/Layout/components/Footer";
import { mapGetters } from "vuex";
import AllNaviData from "@/util/naviData";
export default {
  name: "Home",
  components: {
    SlideLeft,
    SlideRight,
    Navi,
    Container,
    // Footer,
    MsgStatus,
  },
  computed: {
    ...mapGetters(["AppInfo", "isDemo", "defaultLang"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    curRouterPath() {
      this.isHidden = !(this.$route.path == "/dashboard"); //在主页显示右侧边栏
      return this.$route.path;
    },
    naviData() {
      if (this.isDemo) {
        return this.AllNaviData;
      } else {
        return this.curAppInfo ? this.curAppInfo["menus_tree"] : [];
      }
    },
  },
  watch: {
    $route(route) {
      if (route.path === "/dashboard") this.stretchR = true;
      else this.stretchR = false;
    },
    curRouterPath(val) {
      this.isHidden = !(val == "/dashboard");
    },
    popR(val) {
      //在主页控制右侧边栏的显示和隐藏，前提是isHidden=false
      if (val) {
        this.stretchR = false;
      } else {
        this.stretchR = true;
      }
    },
    "$vuetify.breakpoint.lgAndUp": function (val) {
      if (val) this.stretchR = true;
      else this.stretchR = false;
    },
  },
  mounted() {
    const that = this;
    if (this.$vuetify.breakpoint.name == "xs") {
      this.stretchL = false;
    }
    this.getOnLineMenu().then((res) => {
      that.curAppInfo["menus_tree"] = res.data;
      that.$store.dispatch("setAppInfo", JSON.stringify(that.curAppInfo));
    });
  },
  data() {
    return {
      stretchL: true, //是否显示左侧边栏,
      isHidden: true, //默认不显示右侧边栏
      stretchR: true, //是否显示右侧边栏,
      popR: false, //控制全局右侧pop
      AllNaviData: AllNaviData,
    };
  },
  methods: {
    async getOnLineMenu() {
      const that = this;
      return new Promise((reslove, reject) => {
        that
          .$Request({
            method: "POST",
            table: "mrbase_sys_menus",
            url: "/menu/list-user-menus/",
            data: {
              product_shortcode: "ESS", //2021-08-21 dave luo
            },
            type: "lang",
            global: false,
            notAlert: true,
          })
          .then((res) => {
            reslove(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>
